interface Company {
	advices: string
	name: string
	traits: string
}

interface JsonData {
	companies: Company[]
}

export function pathToTitleCase(str: string) {
	const formattedStr = str.replace(/^\//, '').replace(/-/g, ' ')
	return formattedStr.replace(/\b\w/g, (char) => char.toUpperCase())
}

export const removeExtraNewLinesFromTraits = (jsonData: JsonData) => {
	return {
		...jsonData,
		companies: jsonData.companies.map((company: Company) => ({
			...company,
			traits: company.traits.replace(/\n\s*\n/g, '\n'),
		})),
	}
}
